var callable = function callable(possibleFunction) {
  return function () {
    return typeof possibleFunction === 'function' ? possibleFunction.apply(void 0, arguments) : possibleFunction;
  };
};

export default callable;
//# sourceMappingURL=callable.js.map
